import React from "react";

// Honest-zero copy for the Coverage Tracker. Distinguishes State 1 (nothing
// built yet) from State 2 (lessons/units built but none marked taught) using
// `total_activities` from the coverage response, exposed as a stable
// `data-empty-state` signal so a copy edit never changes the behaviour a test
// (or the UI) keys on.
export const HonestZeroNote = ({ totalBuilt = 0, testid = "coverage-empty-state" }) => (
  <p
    className="text-sm text-[#4a6984]/75 leading-relaxed"
    data-testid={testid}
    data-empty-state={totalBuilt > 0 ? "built-untaught" : "nothing-built"}
  >
    {totalBuilt > 0
      ? "Your expectations are saved. Coverage counts what you've taught rather than what you've built, so mark a lesson taught in My Library to see it appear here."
      : "Coverage fills in as you teach. Build a lesson, choose the expectations it covers, and mark it taught in My Library — it'll show up here."}
  </p>
);

export default HonestZeroNote;
